import andoverImg from "@/assets/locations/andover.jpg";
import anokaImg from "@/assets/locations/anoka.jpg";
import ardenHillsImg from "@/assets/locations/arden-hills.jpg";
import blaineImg from "@/assets/locations/blaine.jpg";
import bloomingtonImg from "@/assets/locations/bloomington.jpg";
import brooklynParkImg from "@/assets/locations/brooklyn-park.jpg";
import chanhassenImg from "@/assets/locations/chanhassen.jpg";
import columbiaHeightsImg from "@/assets/locations/columbia-heights.jpg";
import coonRapidsImg from "@/assets/locations/coon-rapids.jpg";
import cottageGroveImg from "@/assets/locations/cottage-grove.jpg";
import crystalImg from "@/assets/locations/crystal.jpg";
import eaganImg from "@/assets/locations/eagan.jpg";
import edenPrairieImg from "@/assets/locations/eden-prairie.jpg";
import edinaImg from "@/assets/locations/edina.jpg";
import excelsiorImg from "@/assets/locations/excelsior.jpg";
import forestLakeImg from "@/assets/locations/forest-lake.jpg";
import fridleyImg from "@/assets/locations/fridley.jpg";
import goldenValleyImg from "@/assets/locations/golden-valley.jpg";
import hopkinsImg from "@/assets/locations/hopkins.jpg";
import lakeElmoImg from "@/assets/locations/lake-elmo.jpg";
import lauderdaleImg from "@/assets/locations/lauderdale.jpg";
import littleCanadaImg from "@/assets/locations/little-canada.jpg";
import mahtomediImg from "@/assets/locations/mahtomedi.jpg";
import mapleGroveImg from "@/assets/locations/maple-grove.jpg";
import minnetonkaImg from "@/assets/locations/minnetonka.jpg";
import newBrightonImg from "@/assets/locations/new-brighton.jpg";
import newHopeImg from "@/assets/locations/new-hope.jpg";
import plymouthImg from "@/assets/locations/plymouth.jpg";
import richfieldImg from "@/assets/locations/richfield.jpg";
import rosevilleImg from "@/assets/locations/roseville.jpg";
import springLakeParkImg from "@/assets/locations/spring-lake-park.jpg";
import springParkImg from "@/assets/locations/spring-park.jpg";
import stAnthonyImg from "@/assets/locations/st-anthony.jpg";
import stLouisParkImg from "@/assets/locations/st-louis-park.jpg";
import stPaulImg from "@/assets/locations/st-paul.jpg";
import stillwaterImg from "@/assets/locations/stillwater.jpg";
import wayzataImg from "@/assets/locations/wayzata.jpg";
import whiteBearLakeImg from "@/assets/locations/white-bear-lake.jpg";
import woodburyImg from "@/assets/locations/woodbury.jpg";
import rochesterImg from "@/assets/locations/rochester.jpg";
import duluthImg from "@/assets/locations/duluth.jpg";
import mankatoImg from "@/assets/locations/mankato.jpg";
import redWingImg from "@/assets/locations/red-wing.jpg";
import owatonnaImg from "@/assets/locations/owatonna.jpg";
import stCloudImg from "@/assets/locations/st-cloud.jpg";
import brainerdImg from "@/assets/locations/brainerd.jpg";
import monticelloImg from "@/assets/locations/monticello.jpg";
import elkRiverImg from "@/assets/locations/elk-river.jpg";
import buffaloImg from "@/assets/locations/buffalo.jpg";
import northfieldImg from "@/assets/locations/northfield.jpg";
import faribaultImg from "@/assets/locations/faribault.jpg";

export interface LocationData {
  slug: string;
  name: string;
  city: string;
  coordinates: [number, number];
  description: string;
  landmarks: string[];
  features: string[];
  image?: string;
}

export const locations: LocationData[] = [
  {
    slug: "andover",
    name: "Andover",
    city: "Andover, MN",
    coordinates: [45.2333, -93.2914],
    description: "Kodiak Structures & Exteriors serves Andover with dependable roofing and exterior services for this growing community in the Twin Cities Metro.",
    landmarks: ["Andover YMCA", "Bunker Hills Golf Course", "Rum River"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: andoverImg,
  },
  {
    slug: "anoka",
    name: "Anoka",
    city: "Anoka, MN",
    coordinates: [45.1975, -93.3869],
    description: "Kodiak Structures & Exteriors proudly serves Anoka — the Halloween Capital of the World — with expert roofing, siding, and exterior services.",
    landmarks: ["Rum River", "Anoka County Fairgrounds", "Historic Downtown Anoka"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: anokaImg,
  },
  {
    slug: "arden-hills",
    name: "Arden Hills",
    city: "Arden Hills, MN",
    coordinates: [45.0503, -93.1572],
    description: "Arden Hills homeowners trust Kodiak Structures & Exteriors for quality roofing and exterior craftsmanship throughout this scenic community.",
    landmarks: ["Land O'Lakes Headquarters", "Arden Hills Army Training Site", "Lake Johanna"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: ardenHillsImg,
  },
  {
    slug: "blaine",
    name: "Blaine",
    city: "Blaine, MN",
    coordinates: [45.1608, -93.2349],
    description: "Blaine homeowners trust Kodiak Structures & Exteriors for reliable roofing and exterior services. Whether you're near the National Sports Center or the Blaine town center, we deliver professional results.",
    landmarks: ["National Sports Center", "Blaine Wetland Sanctuary", "Northtown Mall area"],
    features: ["Roof replacement", "Storm damage repair", "Siding", "Windows", "Gutters"],
    image: blaineImg,
  },
  {
    slug: "bloomington",
    name: "Bloomington",
    city: "Bloomington, MN",
    coordinates: [44.8408, -93.2983],
    description: "Kodiak Structures & Exteriors provides expert roofing and exterior services to Bloomington homeowners, from neighborhoods near the Mall of America to the Minnesota River bluffs.",
    landmarks: ["Mall of America", "Hyland Lake Park Reserve", "Minnesota River Valley"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: bloomingtonImg,
  },
  {
    slug: "brooklyn-park",
    name: "Brooklyn Park",
    city: "Brooklyn Park, MN",
    coordinates: [45.0941, -93.3563],
    description: "Kodiak Structures & Exteriors serves Brooklyn Park with professional roofing, siding, and exterior solutions for one of the largest cities in the Twin Cities Metro.",
    landmarks: ["Edinburgh USA Golf Course", "Brooklyn Park Sports Dome", "Palmer Lake Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: brooklynParkImg,
  },
  {
    slug: "chanhassen",
    name: "Chanhassen",
    city: "Chanhassen, MN",
    coordinates: [44.8622, -93.5308],
    description: "Chanhassen homeowners count on Kodiak Structures & Exteriors for quality roofing and exterior work in this charming lakeside community.",
    landmarks: ["Chanhassen Dinner Theatres", "Minnesota Landscape Arboretum", "Lake Ann"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: chanhassenImg,
  },
  {
    slug: "columbia-heights",
    name: "Columbia Heights",
    city: "Columbia Heights, MN",
    coordinates: [45.0408, -93.2472],
    description: "Kodiak Structures & Exteriors delivers expert roofing and exterior services to Columbia Heights, a well-established inner-ring suburb of Minneapolis.",
    landmarks: ["Huset Park", "Heights Theater", "Sullivan Lake"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: columbiaHeightsImg,
  },
  {
    slug: "coon-rapids",
    name: "Coon Rapids",
    city: "Coon Rapids, MN",
    coordinates: [45.1200, -93.2878],
    description: "Kodiak Structures & Exteriors serves the Coon Rapids community with professional roofing, siding, and exterior solutions. From the Mississippi riverfront to established neighborhoods, we handle it all.",
    landmarks: ["Coon Rapids Dam Regional Park", "Bunker Hills Regional Park", "Riverdale area"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: coonRapidsImg,
  },
  {
    slug: "cottage-grove",
    name: "Cottage Grove",
    city: "Cottage Grove, MN",
    coordinates: [44.8277, -92.9439],
    description: "Kodiak Structures & Exteriors proudly serves Cottage Grove with expert roofing and exterior services for this fast-growing east metro community.",
    landmarks: ["Cottage Grove Ravine Regional Park", "River Oaks Golf Course", "Kingston Trail"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: cottageGroveImg,
  },
  {
    slug: "crystal",
    name: "Crystal",
    city: "Crystal, MN",
    coordinates: [45.0322, -93.3600],
    description: "Crystal homeowners trust Kodiak Structures & Exteriors for reliable roofing and exterior services in this vibrant inner-ring suburb.",
    landmarks: ["Becker Park", "Crystal Airport", "Welcome Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: crystalImg,
  },
  {
    slug: "eagan",
    name: "Eagan",
    city: "Eagan, MN",
    coordinates: [44.8042, -93.1669],
    description: "Kodiak Structures & Exteriors provides top-quality roofing and exterior services to Eagan homeowners throughout this thriving south metro community.",
    landmarks: ["Lebanon Hills Regional Park", "Twin Cities Premium Outlets", "Central Park"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: eaganImg,
  },
  {
    slug: "eden-prairie",
    name: "Eden Prairie",
    city: "Eden Prairie, MN",
    coordinates: [44.8547, -93.4708],
    description: "Eden Prairie homeowners count on Kodiak Structures & Exteriors for expert roofing and exterior craftsmanship in one of Minnesota's top-rated communities.",
    landmarks: ["Eden Prairie Center", "Staring Lake Park", "Purgatory Creek Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: edenPrairieImg,
  },
  {
    slug: "edina",
    name: "Edina",
    city: "Edina, MN",
    coordinates: [44.8897, -93.3500],
    description: "Kodiak Structures & Exteriors delivers premium roofing and exterior services to Edina's discerning homeowners. Quality craftsmanship for a premier community.",
    landmarks: ["Southdale Center", "Centennial Lakes Park", "Edinborough Park"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: edinaImg,
  },
  {
    slug: "excelsior",
    name: "Excelsior",
    city: "Excelsior, MN",
    coordinates: [44.9033, -93.5664],
    description: "Kodiak Structures & Exteriors serves the charming lakeside community of Excelsior with expert roofing and exterior services on Lake Minnetonka.",
    landmarks: ["Excelsior Commons", "Lake Minnetonka", "Downtown Excelsior"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Roof repair"],
    image: excelsiorImg,
  },
  {
    slug: "forest-lake",
    name: "Forest Lake",
    city: "Forest Lake, MN",
    coordinates: [45.2786, -92.9853],
    description: "Forest Lake homeowners trust Kodiak Structures & Exteriors for dependable roofing and exterior services in this beautiful north metro lakeside community.",
    landmarks: ["Forest Lake", "Lakeside Memorial Park", "Headwaters Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: forestLakeImg,
  },
  {
    slug: "fridley",
    name: "Fridley",
    city: "Fridley, MN",
    coordinates: [45.0861, -93.2633],
    description: "Kodiak Structures & Exteriors serves Fridley with professional roofing and exterior solutions along the Mississippi riverfront.",
    landmarks: ["Islands of Peace Park", "Springbrook Nature Center", "Locke Lake"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: fridleyImg,
  },
  {
    slug: "golden-valley",
    name: "Golden Valley",
    city: "Golden Valley, MN",
    coordinates: [44.9908, -93.3589],
    description: "Golden Valley homeowners count on Kodiak Structures & Exteriors for quality roofing and exterior craftsmanship in this well-established inner-ring suburb.",
    landmarks: ["Brookview Park", "Theodore Wirth Park", "Golden Valley Country Club"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: goldenValleyImg,
  },
  {
    slug: "hopkins",
    name: "Hopkins",
    city: "Hopkins, MN",
    coordinates: [44.9250, -93.3983],
    description: "Kodiak Structures & Exteriors proudly serves Hopkins with expert roofing and exterior services for this charming west metro community.",
    landmarks: ["Downtown Hopkins", "Minnehaha Creek Greenway", "Shady Oak Lake"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: hopkinsImg,
  },
  {
    slug: "lake-elmo",
    name: "Lake Elmo",
    city: "Lake Elmo, MN",
    coordinates: [44.9939, -92.8794],
    description: "Kodiak Structures & Exteriors delivers expert roofing and exterior services to Lake Elmo's scenic rural and suburban properties.",
    landmarks: ["Lake Elmo Park Reserve", "Lake Elmo Old Village Hall", "Sunfish Lake"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: lakeElmoImg,
  },
  {
    slug: "lauderdale",
    name: "Lauderdale",
    city: "Lauderdale, MN",
    coordinates: [44.9994, -93.2058],
    description: "Kodiak Structures & Exteriors serves the close-knit Lauderdale community with reliable roofing and exterior services.",
    landmarks: ["Lauderdale Community Park", "University of Minnesota proximity"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: lauderdaleImg,
  },
  {
    slug: "little-canada",
    name: "Little Canada",
    city: "Little Canada, MN",
    coordinates: [45.0275, -93.0867],
    description: "Kodiak Structures & Exteriors provides quality roofing and exterior solutions to Little Canada homeowners throughout this northeast metro community.",
    landmarks: ["Twin Lakes", "Little Canada Park", "Savage Lake"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: littleCanadaImg,
  },
  {
    slug: "mahtomedi",
    name: "Mahtomedi",
    city: "Mahtomedi, MN",
    coordinates: [45.0669, -92.9519],
    description: "Mahtomedi homeowners trust Kodiak Structures & Exteriors for expert roofing and exterior services in this scenic White Bear Lake-area community.",
    landmarks: ["Mahtomedi Beach", "White Bear Lake access", "Wildwood Amusement Park site"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: mahtomediImg,
  },
  {
    slug: "maple-grove",
    name: "Maple Grove",
    city: "Maple Grove, MN",
    coordinates: [45.0725, -93.4558],
    description: "Kodiak Structures & Exteriors serves Maple Grove with professional roofing and exterior services for one of the Twin Cities' fastest-growing communities.",
    landmarks: ["Shoppes at Arbor Lakes", "Elm Creek Park Reserve", "Fish Lake Regional Park"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: mapleGroveImg,
  },
  {
    slug: "minnetonka",
    name: "Minnetonka",
    city: "Minnetonka, MN",
    coordinates: [44.9214, -93.4687],
    description: "Kodiak Structures & Exteriors delivers premium roofing and exterior craftsmanship to Minnetonka homeowners in the heart of the west metro.",
    landmarks: ["Ridgedale Center", "Minnehaha Creek", "Lake Minnetonka access"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: minnetonkaImg,
  },
  {
    slug: "new-brighton",
    name: "New Brighton",
    city: "New Brighton, MN",
    coordinates: [45.0661, -93.2019],
    description: "New Brighton homeowners count on Kodiak Structures & Exteriors for quality roofing and exterior services in this thriving inner-ring suburb.",
    landmarks: ["Long Lake Regional Park", "Northwest Athletic Complex", "Silver Lake"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: newBrightonImg,
  },
  {
    slug: "new-hope",
    name: "New Hope",
    city: "New Hope, MN",
    coordinates: [45.0383, -93.3867],
    description: "Kodiak Structures & Exteriors serves New Hope with dependable roofing and exterior solutions for this well-established northwest metro community.",
    landmarks: ["Civic Center Park", "North Memorial Health Hospital", "Northwood Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: newHopeImg,
  },
  {
    slug: "plymouth",
    name: "Plymouth",
    city: "Plymouth, MN",
    coordinates: [45.0106, -93.4556],
    description: "Plymouth homeowners trust Kodiak Structures & Exteriors for expert roofing and exterior services in the Twin Cities' third-largest city.",
    landmarks: ["French Regional Park", "Wayzata Bay on Medicine Lake", "Plymouth Ice Center"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: plymouthImg,
  },
  {
    slug: "richfield",
    name: "Richfield",
    city: "Richfield, MN",
    coordinates: [44.8831, -93.2833],
    description: "Kodiak Structures & Exteriors delivers reliable roofing and exterior services to Richfield homeowners in this conveniently located inner-ring suburb.",
    landmarks: ["Wood Lake Nature Center", "Richfield Bandshell", "Veterans Park"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: richfieldImg,
  },
  {
    slug: "roseville",
    name: "Roseville",
    city: "Roseville, MN",
    coordinates: [45.0061, -93.1567],
    description: "Kodiak Structures & Exteriors proudly serves Roseville with expert roofing and exterior services at the crossroads of Minneapolis and St. Paul.",
    landmarks: ["Rosedale Center", "Harriet Alexander Nature Center", "Central Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: rosevilleImg,
  },
  {
    slug: "st-anthony",
    name: "St. Anthony",
    city: "St. Anthony, MN",
    coordinates: [45.0208, -93.2181],
    description: "St. Anthony Village homeowners trust Kodiak Structures & Exteriors for quality roofing and exterior craftsmanship in this charming community.",
    landmarks: ["Silver Lake Park", "St. Anthony Village Shopping Center", "Kenzie Terrace Park"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: stAnthonyImg,
  },
  {
    slug: "st-louis-park",
    name: "St. Louis Park",
    city: "St. Louis Park, MN",
    coordinates: [44.9483, -93.3483],
    description: "Kodiak Structures & Exteriors serves St. Louis Park with professional roofing and exterior services for this popular first-ring suburb of Minneapolis.",
    landmarks: ["The Shops at West End", "Wolfe Park", "Westwood Hills Nature Center"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: stLouisParkImg,
  },
  {
    slug: "spring-lake-park",
    name: "Spring Lake Park",
    city: "Spring Lake Park, MN",
    coordinates: [45.1078, -93.2381],
    description: "Kodiak Structures & Exteriors provides dependable roofing and exterior services to Spring Lake Park homeowners in the north metro.",
    landmarks: ["Spring Lake Park", "North Hennepin Trail Corridor", "Sanburnol Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: springLakeParkImg,
  },
  {
    slug: "spring-park",
    name: "Spring Park",
    city: "Spring Park, MN",
    coordinates: [44.9350, -93.6314],
    description: "Kodiak Structures & Exteriors delivers expert roofing and exterior services to Spring Park on the shores of Lake Minnetonka.",
    landmarks: ["Lake Minnetonka", "Spring Park Town Center", "Maxwell Bay"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: springParkImg,
  },
  {
    slug: "st-paul",
    name: "St. Paul",
    city: "St. Paul, MN",
    coordinates: [44.9537, -93.0900],
    description: "Kodiak Structures & Exteriors serves Minnesota's capital city with expert roofing and exterior services, from historic homes to modern neighborhoods across St. Paul.",
    landmarks: ["Cathedral of Saint Paul", "Summit Avenue", "Como Park Zoo & Conservatory"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: stPaulImg,
  },
  {
    slug: "stillwater",
    name: "Stillwater",
    city: "Stillwater, MN",
    coordinates: [45.0564, -92.8058],
    description: "Stillwater homeowners trust Kodiak Structures & Exteriors for quality roofing and exterior work in Minnesota's birthplace on the scenic St. Croix River.",
    landmarks: ["Historic Downtown Stillwater", "Stillwater Lift Bridge", "Brown's Creek State Trail"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: stillwaterImg,
  },
  {
    slug: "wayzata",
    name: "Wayzata",
    city: "Wayzata, MN",
    coordinates: [44.9742, -93.5069],
    description: "Kodiak Structures & Exteriors delivers premium roofing and exterior services to Wayzata homeowners on the shores of Lake Minnetonka.",
    landmarks: ["Wayzata Bay", "Downtown Wayzata", "Lake Minnetonka"],
    features: ["Roof replacement", "Siding", "Windows", "Gutters", "Storm damage"],
    image: wayzataImg,
  },
  {
    slug: "white-bear-lake",
    name: "White Bear Lake",
    city: "White Bear Lake, MN",
    coordinates: [45.0836, -93.0097],
    description: "White Bear Lake homeowners count on Kodiak Structures & Exteriors for expert roofing and exterior services in this beloved northeast metro lakeside community.",
    landmarks: ["White Bear Lake", "Manitou Island", "Downtown White Bear Lake"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: whiteBearLakeImg,
  },
  {
    slug: "woodbury",
    name: "Woodbury",
    city: "Woodbury, MN",
    coordinates: [44.9239, -92.9594],
    description: "Kodiak Structures & Exteriors serves Woodbury — one of Minnesota's fastest-growing cities — with expert roofing, siding, and exterior services.",
    landmarks: ["Carver Lake Park", "Bielenberg Sports Center", "Woodbury Lakes Shopping"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: woodburyImg,
  },

  // --- Greater Minnesota ---
  {
    slug: "rochester",
    name: "Rochester",
    city: "Rochester, MN",
    coordinates: [44.0234, -92.463],
    description: "Kodiak Structures & Exteriors serves Rochester with roof replacement, storm damage restoration and full exterior work across Olmsted County.",
    landmarks: ["Mayo Clinic", "Silver Lake", "Soldiers Field Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: rochesterImg,
  },
  {
    slug: "duluth",
    name: "Duluth",
    city: "Duluth, MN",
    coordinates: [46.7838, -92.1053],
    description: "Kodiak Structures & Exteriors serves Duluth with roofing and exterior work built for lake wind, heavy snow and some of the oldest housing stock in Minnesota.",
    landmarks: ["Lake Superior", "Aerial Lift Bridge", "Skyline Parkway"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: duluthImg,
  },
  {
    slug: "st-cloud",
    name: "St. Cloud",
    city: "St. Cloud, MN",
    coordinates: [45.5616, -94.1642],
    description: "Kodiak Structures & Exteriors serves St. Cloud with roof replacement, siding and storm damage work across Stearns and Benton counties.",
    landmarks: ["Mississippi River", "St. Cloud State University", "Munsinger Gardens"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: stCloudImg,
  },
  {
    slug: "mankato",
    name: "Mankato",
    city: "Mankato, MN",
    coordinates: [44.1659, -94.0028],
    description: "Kodiak Structures & Exteriors serves Mankato with roofing, siding and gutter work for both the river valley and the hilltop neighborhoods above it.",
    landmarks: ["Minnesota River", "Minnesota State University", "Sibley Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: mankatoImg,
  },
  {
    slug: "brainerd",
    name: "Brainerd",
    city: "Brainerd, MN",
    coordinates: [46.358, -94.2008],
    description: "Kodiak Structures & Exteriors serves Brainerd and the lakes area with roofing built for deep snow load, including work on seasonal and lake properties.",
    landmarks: ["Gull Lake", "Mississippi River", "Northland Arboretum"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: brainerdImg,
  },
  {
    slug: "monticello",
    name: "Monticello",
    city: "Monticello, MN",
    coordinates: [45.3054, -93.794],
    description: "Kodiak Structures & Exteriors serves Monticello with roof replacement, siding and storm damage work along the I-94 growth corridor in Wright County.",
    landmarks: ["Mississippi River", "Bertram Chain of Lakes", "I-94 corridor"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: monticelloImg,
  },
  {
    slug: "elk-river",
    name: "Elk River",
    city: "Elk River, MN",
    coordinates: [45.3039, -93.5672],
    description: "Kodiak Structures & Exteriors serves Elk River with roofing, siding and gutter work for one of the fastest growing cities in Sherburne County.",
    landmarks: ["Mississippi River", "Lake Orono", "Woodland Trails Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: elkRiverImg,
  },
  {
    slug: "buffalo",
    name: "Buffalo",
    city: "Buffalo, MN",
    coordinates: [45.1719, -93.8747],
    description: "Kodiak Structures & Exteriors serves Buffalo with roof replacement, siding and exterior repair across the Wright County lakes area.",
    landmarks: ["Buffalo Lake", "Wright County Fairgrounds", "Sturges Park"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: buffaloImg,
  },
  {
    slug: "northfield",
    name: "Northfield",
    city: "Northfield, MN",
    coordinates: [44.4582, -93.1612],
    description: "Kodiak Structures & Exteriors serves Northfield with roofing and exterior work suited to a town full of genuinely old housing.",
    landmarks: ["Cannon River", "St. Olaf College", "Carleton College"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: northfieldImg,
  },
  {
    slug: "red-wing",
    name: "Red Wing",
    city: "Red Wing, MN",
    coordinates: [44.5625, -92.5338],
    description: "Kodiak Structures & Exteriors serves Red Wing with roofing and exterior work built for bluff-top wind exposure above the Mississippi.",
    landmarks: ["Barn Bluff", "Mississippi River", "Red Wing Pottery"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: redWingImg,
  },
  {
    slug: "faribault",
    name: "Faribault",
    city: "Faribault, MN",
    coordinates: [44.295, -93.2688],
    description: "Kodiak Structures & Exteriors serves Faribault with roof replacement, siding and gutter work across Rice County.",
    landmarks: ["Cannon River", "Faribault Woolen Mill", "River Bend Nature Center"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: faribaultImg,
  },
  {
    slug: "owatonna",
    name: "Owatonna",
    city: "Owatonna, MN",
    coordinates: [44.084, -93.2261],
    description: "Kodiak Structures & Exteriors serves Owatonna with roofing, siding and storm damage work along the I-35 corridor in Steele County.",
    landmarks: ["National Farmers Bank", "Straight River", "Kaplan's Woods"],
    features: ["Roof replacement", "Roof repair", "Siding", "Windows", "Gutters"],
    image: owatonnaImg,
  },
];

export const getLocationBySlug = (slug: string): LocationData | undefined => {
  return locations.find((loc) => loc.slug === slug);
};
